var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosGoogleCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_29537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5261 9.97461H9.47363V31.0271H30.5261V9.97461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5266 40.5006L40.0004 31.0269L35.2635 30.2188L30.5266 31.0269L29.6621 35.3597L30.5266 40.5006Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.0269V37.3427C0 39.0875 1.41312 40.5006 3.15781 40.5006H9.47375L10.4464 35.7638L9.47375 31.0269L4.31234 30.2188L0 31.0269Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 9.97375V3.65781C40.0004 1.91312 38.5873 0.5 36.8426 0.5H30.5266C29.9504 2.84938 29.6621 4.57828 29.6621 5.68687C29.6621 6.79531 29.9504 8.22437 30.5266 9.97375C32.622 10.5737 34.2009 10.8737 35.2635 10.8737C36.3262 10.8737 37.9051 10.5737 40.0004 9.97375Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 9.97461H30.5264V31.0271H40.0001V9.97461Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5261 31.0254H9.47363V40.4991H30.5261V31.0254Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5262 0.5H3.15797C1.41313 0.5 0 1.91312 0 3.65781V31.0262H9.47375V9.97375H30.5262V0.5Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7921 26.3048C13.0053 25.7733 12.4604 24.997 12.1631 23.9705L13.9895 23.218C14.1551 23.8495 14.4446 24.3391 14.8579 24.6864C15.2684 25.0337 15.7684 25.2048 16.3526 25.2048C16.95 25.2048 17.4631 25.0233 17.892 24.66C18.3211 24.2969 18.5368 23.8337 18.5368 23.2733C18.5368 22.6995 18.3104 22.2311 17.8579 21.868C17.4053 21.5048 16.8368 21.3233 16.1579 21.3233H15.1026V19.5155H16.05C16.6342 19.5155 17.1262 19.3575 17.5262 19.0416C17.9262 18.7259 18.1262 18.2942 18.1262 17.7442C18.1262 17.2548 17.9473 16.8653 17.5895 16.5733C17.2317 16.2811 16.7789 16.1337 16.2289 16.1337C15.692 16.1337 15.2657 16.2759 14.95 16.5627C14.6344 16.8503 14.3971 17.2134 14.2604 17.618L12.4526 16.8653C12.692 16.1864 13.1315 15.5864 13.7762 15.068C14.4211 14.5495 15.2446 14.2891 16.2446 14.2891C16.9842 14.2891 17.65 14.4313 18.2395 14.718C18.8289 15.0048 19.292 15.4022 19.6262 15.9075C19.9606 16.4153 20.1262 16.9837 20.1262 17.6153C20.1262 18.26 19.9711 18.8048 19.6606 19.2522C19.35 19.6995 18.9684 20.0416 18.5157 20.2811V20.3889C19.1002 20.6299 19.6079 21.0257 19.9842 21.5337C20.3657 22.0469 20.5579 22.66 20.5579 23.3759C20.5579 24.0916 20.3762 24.7311 20.0131 25.2916C19.65 25.8522 19.1475 26.2942 18.5104 26.6153C17.8711 26.9364 17.1526 27.0997 16.3553 27.0997C15.4315 27.1022 14.5789 26.8364 13.792 26.3048H13.7921ZM25.0104 17.2416L23.0053 18.6916L22.0026 17.1706L25.6 14.5758H26.9789V26.8153H25.0104V17.2417V17.2416Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_29537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGoogleCalendar);
export default __webpack_public_path__ + "static/media/logos_google-calendar.5108cf3bd0a235a99d37a6faf890f383.svg";
export { ForwardRef as ReactComponent };